<!--文本类型组件-->
<template>
  <div
    class="text-wrap"
    :style="{
      fontFamily:config.fontFamily?config.fontFamily:'auto',
    }"
  >
    <ul>
      <li
        v-for="(item, index) in textRow"
        :key="index"
        :style="{
          marginLeft: config.offsetX + 'px',
          marginTop: config.offsetY + 'px'
        }"
      >
        <span
          class="label"
          :style="{
            minWidth: config.text.minWidth + 'px',
            fontSize: item.tSize + 'px',
            color: item.tColor
          }"
        >{{ item['label'] }}</span>
        <span
          class="value"
          :class="[config.value.isOverflow ? 'valueSpace' : '']"
          :style="{
            fontSize: item.vSize+ 'px',
            color: item.vColor
          }"
        >{{ chartData[0][item['value']] }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    textRow () {
      let temp = this.config.textRow
      temp = temp.map(item => {
        return {
          label: item.children[0].value,
          value: item.children[1].value,
          tSize: item.children[2].value[0],
          tColor: item.children[2].value[1],
          vSize: item.children[3].value[0],
          vColor: item.children[3].value[1]
        }
      })
      return temp
    }
  },
  name: 'TextC'
}
</script>

<style lang="stylus" scoped>
.text-wrap
  li
    display flex
    align-items center
    margin-bottom 10px
    min-height 22px
    line-height 22px
    color: #fff;
    .value
      flex 1
    .valueSpace
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
</style>
